// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toaster-alert[data-v-4fa2eeec]{position:fixed;bottom:24px;left:50%;z-index:99999;width:343px;transform:translateX(-50%)}.toaster-alert__item[data-v-4fa2eeec]:not(:last-child){margin-bottom:var(--spaces-m)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
